export default "__VITE_ASSET__DOK7r3Au__"